import React from "react";
import ageRanges from "../../data/ageRanges";
import biologicalSexList from "../../data/biologicalSex";
import jobArea from "../../data/jobArea";
import CgsSummaryChart from "../../components/analytics/CgsSummaryChart";
import styles from "./CgsAnalyticsPage.module.css";

const filterConfigs = [
  { name: "ageRange", label: "Rango de edad", options: ageRanges },
  { name: "jobArea", label: "Área de trabajo", options: jobArea },
  { name: "biologicalSex", label: "Sexo biológico", options: biologicalSexList }
];

const chartConfigs = [
  {
    key: "bai",
    metricKey: "bai",
    title: "Cuestionario de Ansiedad de Beck",
    colors: ["var(--color-delilife)", "var(--color-amarillo)", "var(--color-rojo)"]
  },
  {
    key: "bdi",
    metricKey: "bdi",
    title: "Inventario de Depresión de Beck (BDI)",
    colors: ["var(--color-delilife)", "var(--color-amarillo)", "#FFA500", "var(--color-rojo)"]
  },
  {
    key: "psqi",
    metricKey: "psqi",
    title: "Índice de Calidad de Sueño de Pittsburgh",
    colors: ["var(--color-delilife)", "var(--color-rojo)"]
  },
  {
    key: "pss",
    metricKey: "pss",
    title: "Escala de Estrés Percibido",
    colors: ["var(--color-delilife)", "var(--color-amarillo)", "var(--color-rojo)"]
  }
];

export default function CgsAnalyticsGlobalPage() {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.title}>Analítica Global Evaluación Integral de Bienestar Emocional</h2>
      </header>

      <section className={styles.chartsGrid}>
        {chartConfigs.map((chart) => (
          <div className={styles.chartCard} key={chart.key}>
            <CgsSummaryChart
              title={chart.title}
              metricKey={chart.metricKey}
              isGlobal
              filterConfigs={filterConfigs}
              colors={chart.colors}
            />
          </div>
        ))}
      </section>
    </div>
  );
}
